import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vShow as _vShow, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "ofh kakugo w100 posFi shadowContent messageHeader skyblueBg",
  style: {"top":"0","z-index":"10"}
}
const _hoisted_2 = {
  key: 0,
  class: "ofh w14 fl navBarReturn whiteColor",
  style: {"background":"#111"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "ofh fl navBarTitle" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fs13 whiteColor" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WhatStrictCal = _resolveComponent("WhatStrictCal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.href && !_ctx.href.includes(`/start`) && _ctx.showBackButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickBack && _ctx.clickBack(...args)))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(`kakugo pointer ${_ctx.isSP ? 'fs13' : 'ls1 fs13'}`),
              style: {"margin-left":"20px","margin-top":"0","line-height":"68px"}
            }, [
              _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/leftArrow_lgrey.png`),
                  width: "15",
                  height: "19",
                  style: {"margin-top":"-4px"}
                }, null, 8, _hoisted_3),
                (!_ctx.isSP)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "戻る"))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/logo/waaqLink_logo_white_flat.gif`),
        class: "serviceLogo fl",
        style: _normalizeStyle({
                    width: `130px`,
                    marginLeft: _ctx.isSP ? `10px` : `30px`,
                    marginTop: _ctx.isSP ? `10px` : `8px`,
                })
      }, null, 12, _hoisted_6),
      (_ctx.isSP)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("h4", {
        class: _normalizeClass(`kakugo fl ${_ctx.isSP ? 'fs14' : 'ls1 fs14'}`),
        style: _normalizeStyle({
                    marginLeft: _ctx.isSP ? `10px` : `30px`,
                    marginTop: _ctx.isSP ? `8px` : ``,
                    color: `#fafafa`,
                })
      }, [
        (!_ctx.isSP)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "|  "))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: "fw600",
          style: _normalizeStyle({
                        marginLeft: _ctx.isSP ? `2px` : ``,
                    })
        }, _toDisplayString(_ctx.pageTitle), 5)
      ], 6),
      _withDirectives(_createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/change_wt.png`),
        class: "fl pointer",
        style: _normalizeStyle({
                    width: `36px`,
                    marginTop: _ctx.isSP ? `-13px` : `0px`,
                    marginLeft: _ctx.isSP ? `10px` : `30px`,
                }),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickChange && _ctx.clickChange(...args)))
      }, null, 12, _hoisted_11), [
        [_vShow, _ctx.showChangeAstagIcon()],
        [
          _directive_tooltip,
          `調整カレンダー切り替え`,
          void 0,
          { bottom: true }
        ]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/add_cal_wt_.png`),
        class: "fl pointer",
        style: _normalizeStyle({
                    width: `42px`,
                    marginTop: _ctx.isSP ? `-13px` : `-2px`,
                    marginLeft: _ctx.isSP ? `10px` : `30px`,
                }),
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickNew && _ctx.clickNew(...args)))
      }, null, 12, _hoisted_12), [
        [_vShow, _ctx.showChangeAstagIcon()],
        [
          _directive_tooltip,
          `新規作成`,
          void 0,
          { bottom: true }
        ]
      ]),
      (_ctx.buttonTitle && !_ctx.isSuspend)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "submit",
            class: _normalizeClass(`circle_button pinkBg fffColor fr centered fw600 ${_ctx.buttonEnabled ? `` : `disabled`}`),
            style: _normalizeStyle({
                    position: _ctx.isSP ? `absolute` : `relative`,
                    right: _ctx.isSP ? `5px` : ``,
                    top: _ctx.isSP ? `12px` : ``,
                    minWidth: _ctx.isSP ? `` : `140px`,
                    marginRight: _ctx.isSP ? `` : `20px`,
                    border: `1px solid #3c3f98`,
                    padding: `6px 12px`,
                }),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickPinkButton && _ctx.clickPinkButton(...args)))
          }, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.buttonTitle), 1)
          ], 6))
        : _createCommentVNode("", true),
      (_ctx.showWhatCal && _ctx.rm.tutorial_phase >= 9)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (!_ctx.isSP)
              ? (_openBlock(), _createBlock(_component_WhatStrictCal, { key: 0 }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_15
  ]))
}